<div class="mb-4">
  <div
    #autocompleteContainer
    class="custom-autocomplete-container"
    [class.custom-autocomplete-focused]="focused"
    [class.custom-autocomplete-disabled]="disabled"
    [class.custom-autocomplete-error]="showError"
    [class.error]="showError"
    [class.custom-autocomplete-has-value]="hasValue">
    <!-- Form field wrapper -->
    <div class="custom-autocomplete-field">
      <!-- Label -->
      <label class="custom-autocomplete-label" [class.custom-autocomplete-label-floating]="isFloatingLabel">
        {{ label }}
        <span *ngIf="required" class="custom-autocomplete-required">*</span>
      </label>

      <!-- Input element -->
      <input
        #inputElement
        type="text"
        class="custom-autocomplete-input"
        [placeholder]="isFloatingLabel ? placeholder : ''"
        [disabled]="disabled"
        [value]="inputValue"
        (pointerdown)="onInputPointerDown($event)"
        (input)="onInputChange($event)"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (keydown)="onInputKeyDown($event)"
        autocomplete="off"
        role="combobox"
        [attr.aria-expanded]="isOpen"
        [attr.aria-autocomplete]="'list'"
        [attr.aria-haspopup]="'listbox'" />

      <!-- Dropdown arrow -->
      <button
        type="button"
        class="custom-autocomplete-arrow"
        (pointerdown)="onArrowPointerDown($event)"
        (click)="onArrowClick($event)"
        [disabled]="disabled"
        [attr.aria-label]="isOpen ? 'Close options' : 'Open options'">
        <mat-icon [class.custom-autocomplete-arrow-open]="isOpen">keyboard_arrow_down</mat-icon>
      </button>
    </div>

    <!-- Dropdown options -->
    <div
      #dropdown
      class="custom-autocomplete-dropdown"
      [class.custom-autocomplete-dropdown-open]="isOpen"
      (pointerdown)="onDropdownPointerDown()"
      (pointermove)="onDropdownPointerMove()"
      (pointerup)="onDropdownPointerUp()"
      (pointercancel)="onDropdownPointerUp()"
      role="listbox">
      <div class="custom-autocomplete-options">
        <div
          *ngFor="let option of filteredOptions; let i = index; trackBy: trackByValue"
          class="custom-autocomplete-option"
          [class.custom-autocomplete-option-selected]="option.value === selectedValue"
          [class.custom-autocomplete-option-highlighted]="i === highlightedIndex"
          [class.custom-autocomplete-option-disabled]="option.disabled"
          (click)="selectOption(option)"
          (mouseenter)="highlightedIndex = i"
          role="option"
          [attr.aria-selected]="option.value === selectedValue">
          {{ option.label }}
        </div>

        <!-- No options message -->
        <div
          *ngIf="filteredOptions.length === 0 && inputValue.length >= minSearchLength"
          class="custom-autocomplete-no-options">
          No options found
        </div>

        <!-- Type to search message -->
        <div *ngIf="inputValue.length < minSearchLength && minSearchLength > 0" class="custom-autocomplete-no-options">
          Type {{ minSearchLength }} or more characters to search
        </div>
      </div>
    </div>
  </div>

  <!-- Error message -->
  <div *ngIf="showError && errorMessage" class="custom-autocomplete-error-message" [innerHTML]="errorMessage"></div>
</div>
